class CartNotification extends HTMLElement {
  constructor() {
    super();
    this.IS_CART_PAGE = document.body.classList.contains('cart') ? true : false;
    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.classList.add('animate', 'active');
    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
      this.cartItemKey = parsedState.key;
      this.getSectionsToRender().forEach((section => {

        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }));

      if (this.header && !this.IS_CART_PAGE) this.header.reveal();
      this.updateShippingBars();
      if(!this.IS_CART_PAGE)this.open();
  }

  updateShippingBars() {
    const shippingBars = document.querySelectorAll('.js-shipping-bar')
    shippingBars.forEach(shippingBar => updateBar(shippingBar))

    async function updateBar(bar) {
      try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      const freeShippingThreshold = bar.getAttribute('threshold') || 100;
      const progressBar = bar.querySelector('.progress-bar__bar');
      const progressNumber = bar.querySelector('.progress-bar__message b');


        // Fetch cart data from Shopify Cart API
  
        // Extract relevant cart data
        const cartCurrency = new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency: 'GBP'
        });
        const subtotal = cart.total_price;
        const progress = Math.min(subtotal / freeShippingThreshold, 1); // Calculate the progress towards free shipping
        const progressPercent = Math.round(progress * 100); // Calculate the progress percentage
        const currentTarget = (((freeShippingThreshold - subtotal) / 100) * 1);
  
        // Update DOM elements with cart data
        progressBar.style = `--progress:${progressPercent}%;`; // Update the width of the progress bar element
        progressBar.setAttribute('aria-valuenow', progressPercent); // Set the progress percentage as the ARIA value
  
        // Update classList based on condition
        if (subtotal >= freeShippingThreshold) {
          bar.setAttribute('filled', '');
        } else {
          bar.removeAttribute('filled');
        }
  
        progressNumber.innerHTML = `${cartCurrency.formatToParts(1)[0].value}${currentTarget}`;
      } catch (error) {
        console.log("Error fetching cart data from Shopify Cart API:", error);
      }
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
